import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthProvider';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { PublicRoute } from '@/components/auth/PublicRoute';
import { AppLayout } from '@/components/layout/AppLayout';
import { LoginPage } from '@/pages/LoginPage/LoginPage';
import { AuthCallback } from '@/pages/AuthCallback/AuthCallback';
import { OnboardingPage } from '@/pages/OnboardingPage/OnboardingPage';
import { DashboardPage } from '@/pages/DashboardPage/DashboardPage';
import AssetsPage from '@/pages/AssetsPage/AssetsPage';
import { CashflowPage } from '@/pages/CashflowPage/CashflowPage';
import { GoalsPage } from '@/pages/GoalsPage/GoalsPage';
import { ResidencyPage } from '@/pages/ResidencyPage/ResidencyPage';
import { SimulatorPage } from '@/pages/SimulatorPage/SimulatorPage';
import { TaxPage } from '@/pages/TaxPage/TaxPage';
import { PensionPage } from '@/pages/PensionPage/PensionPage';
import { HealthcareBridgePage } from '@/pages/HealthcareBridgePage/HealthcareBridgePage';
import { ProfilePage } from '@/pages/ProfilePage/ProfilePage';

export function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <AppLayout>
                    <Routes>
                        <Route
                            path="/"
                            element={
                                <PublicRoute>
                                    <LoginPage />
                                </PublicRoute>
                            }
                        />
                        <Route path="/auth/callback" element={<AuthCallback />} />
                        <Route
                            path="/onboarding"
                            element={
                                <ProtectedRoute>
                                    <OnboardingPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <DashboardPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/assets"
                            element={
                                <ProtectedRoute>
                                    <AssetsPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/cashflows"
                            element={
                                <ProtectedRoute>
                                    <CashflowPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/goals"
                            element={
                                <ProtectedRoute>
                                    <GoalsPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/residency"
                            element={
                                <ProtectedRoute>
                                    <ResidencyPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/simulator"
                            element={
                                <ProtectedRoute>
                                    <SimulatorPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/tax"
                            element={
                                <ProtectedRoute>
                                    <TaxPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/pensions"
                            element={
                                <ProtectedRoute>
                                    <PensionPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/healthcare-bridge"
                            element={
                                <ProtectedRoute>
                                    <HealthcareBridgePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/profile"
                            element={
                                <ProtectedRoute>
                                    <ProfilePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </AppLayout>
            </AuthProvider>
        </BrowserRouter>
    );
}
